class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.onSubmitHandler.bind(this));
    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.learnwellQuantityBreaks('ProductGridContainer');
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchURL = event.state ? event.state.searchURL : FacetFiltersForm.searchURLInitial;
      if (searchURL === FacetFiltersForm.searchURLPrev) return;
      FacetFiltersForm.renderPage(searchURL, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchURL, event, updateURLHash = true) {
    FacetFiltersForm.searchURLPrev = searchURL;
        
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {    	
      const url = `${searchURL}#${section.section}`;
      
      const filterDataUrl = element => element.url === url;
      
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchURL);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    FacetFiltersForm.learnwellQuantityBreaks('ProductGridContainer');
  }

  static learnwellQuantityBreaks(id) {
    var productids = [];
    document.getElementById(id).querySelectorAll('.productcard[data-productid]').forEach((element) => {
        productids.push(element.dataset.productid);
    });
    if (productids.length) {
        productids = productids.join(',');
        var url = "https://apps.boldapps.net/pricerules/esa-publications.myshopify.com/rulesets?products="+productids;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onreadystatechange = function () {
            var qbdata = {};
            if (xhr.readyState === 4) {
                var response = JSON.parse(xhr.responseText);
                response.rulesets.forEach((element) => {
                    if (element.product_selection.type=='SHOPIFY_PRODUCT_SEARCH') {
                        element.rules.forEach((rule) => {
                            if (rule.type=='DISPLAY') {
                                rule.actions.forEach((action) => {
                                    if (action.type=='DISPLAY_QTY_BREAK') {
                                        var qty = action.qty;
                                        var price = action.price;
                                        element.product_selection.products.forEach((product) => {
                                            var prodid = product.product_id;
                                            if (!qbdata.hasOwnProperty(prodid) || qty < qbdata[prodid]['qty']) {
                                                qbdata[prodid] = {};
                                                qbdata[prodid]['qty'] = qty;
                                                qbdata[prodid]['price'] = (price / 100.0).toFixed(2);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });        
                document.getElementById(id).querySelectorAll('.productcard[data-productid]').forEach((element) => {
                    if (qbdata.hasOwnProperty(element.dataset.productid)) {
                        element.querySelector('.price__regular .price-discount').innerHTML = 'or <span>$'+qbdata[element.dataset.productid]['price']+'</span> for '+qbdata[element.dataset.productid]['qty']+'+';
                    }
                });            
            }
        };
        xhr.send();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterEl = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      filterEl.innerHTML = element.innerHTML;
      if (element.classList.contains('emptyfilter')) filterEl.classList.add('emptyfilter');
      else filterEl.classList.remove('emptyfilter');
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchURL) {
    history.pushState({ searchURL }, '', searchURL);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const tags = [];
    if (formData.has('Filter_Type')) {
    	const value = formData.get('Filter_Type');
    	if (value.length) tags.push(value);
    	formData.delete('Filter_Type');
    }
    if (formData.has('Filter_Year')) {
    	const value = formData.get('Filter_Year');
    	if (value.length) tags.push(value);
    	formData.delete('Filter_Year');
    }
    if (formData.has('Filter_Area')) {
    	const value = formData.get('Filter_Area');
    	if (value.length) tags.push(value);
    	formData.delete('Filter_Area');
    }
    if (formData.has('Filter_Subject')) {
    	const value = formData.get('Filter_Subject');
    	if (value.length) tags.push(value);
    	formData.delete('Filter_Subject');
    }    
    return {
          search:new URLSearchParams(formData).toString(),
    		tags:tags.join('+')
        };
  }
  
  onSubmitForm(baseURL, searchParams, event) {
    FacetFiltersForm.renderPage(baseURL+"?"+searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    if (event.target.name=='Filter_Area') {
    	event.target.closest('form').querySelector("input[name='Filter_Subject'][value='']").checked = true;
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      /*
      const facetdetails = event.target.closest('details');
      const menudrawer = event.target.closest('menu-drawer');
      menudrawer.closeSubmenu(facetdetails);
      */
      const form = event.target.closest('form');
      const formret = this.createSearchParams(form)
      this.onSubmitForm(form.dataset.baseurl+(formret.tags.length ? '/'+formret.tags:''),formret.search, event)
    } else {
      const forms = [];
      const tags = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      
      if (event.srcElement.type=='radio') {
      		event.srcElement.closest('details').querySelector('summary').click();
      }
      
      var baseURL = '';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          	const formret = this.createSearchParams(form);
          	forms.push(formret.search);
          	if (formret.tags.length) tags.push(formret.tags);
		baseURL = form.dataset.baseurl;
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          	const formret = this.createSearchParams(form);
          	forms.push(formret.search);
          	if (formret.tags.length) tags.push(formret.tags);
		baseURL = form.dataset.baseurl;
        }
      });
      this.onSubmitForm(baseURL+(tags.length ? '/'+tags.join('+') : ''),forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(event.currentTarget.href);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchURLInitial = window.location.pathname + window.location.search;
FacetFiltersForm.searchURLPrev = window.location.pathname + window.location.search;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);